<template>
  <div>
    <!-- 1.面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>
        课题类别管理
      </el-breadcrumb-item>
      <el-breadcrumb-item>课题类别管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 2.搜索框 -->
      <el-row class="row-search">
        <el-col class="el-col-user-add">
          <el-input class="user-search" clearable placeholder="请输课题类别信息（用空格分隔），支持模糊搜索" v-model="query">
            <el-button slot="append" icon="el-icon-search" @click.prevent="queryUser()"></el-button>
          </el-input>
          <el-button class="bt-user-add" type="success" plain @click.prevent="showAddCategoryForm()">新增课题类别</el-button>
        </el-col>
      </el-row>
      <!-- <h3>注意：只能存在一个激活的课题类别！</h3> -->
      <!-- 3.表格 -->
      <el-table :data="users" style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="名称" width="280"></el-table-column>
        <el-table-column prop="desc" label="描述" width="520"></el-table-column>
        <el-table-column label="编辑课题方向" width="140">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="primary" icon="el-icon-tickets" circle
              @click="showEditDirectionForm(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="课题类型" width="260">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.type" size="mini" @change=changeType(scope.row)>
              <el-radio-button label="一般课题"></el-radio-button>
              <el-radio-button label="青年课题"></el-radio-button>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="is_active" label="状态" width="60">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.is_active" active-color="#13ce66" inactive-color="#ff4949"
              @change="categoryIsActive(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="primary" icon="el-icon-edit" circle
              @click="showEditCategoryForm(scope.row.id)"></el-button>
            <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
              @click="deleteCategory(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 4.分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
      <!-- 对话框 -->
      <!-- 5.添加对话框 -->
      <el-dialog title="新增课题类别" :visible.sync="addCategoryFormVisible">
        <el-form label-position="left" label-width="80px" :model="addCategoryForm" :rules="addCategoryFormRules">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addCategoryForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input v-model="addCategoryForm.desc" type="textarea" :rows="2" placeholder="请输入描述内容"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addCategoryFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addCategorFormButton()">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 修改对话框 -->
      <el-dialog title="修改课题类别信息" :visible.sync="editCategoryFormVisible">
        <el-form label-position="left" label-width="80px" :model="editUserForm" :rules="addCategoryFormRules">
          <el-form-item label="名称" prop="name">
            <el-input v-model="editUserForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input v-model="editUserForm.desc" type="textarea" :rows="2" placeholder="请输入描述内容"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editCategoryFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="editCategoryFormButton()">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 编辑课题类别对话框 20210418 课题类别修改为两层-->
      <el-dialog :title="'编辑《 ' + category.name + '》课题方向'" :visible.sync="editDirectionFormVisible">
        <div class="div-directions" v-for="item in directions" :key="item.index">
          <el-form>
            <el-form-item label="名称">
              <el-input v-model="item.name"></el-input>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="item.desc" type="textarea" :row="2"></el-input>
            </el-form-item>
            <el-button type="primary" @click="deleteDirection(item.index)">删除</el-button>
          </el-form>

          <!-- 20230424 课题方向内新增课题名称，整体修改为3层 -->
          <div class="div-projectNames">
            <el-button type="primary" @click="addProjectName(item.index)">新增课题名称</el-button>
            <div v-for="(p, index) in item.projectNames" :key="index">
              <el-form class="form-projectNames">
                <el-form-item label="课题名称">
                  <el-input v-model="p.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                  <el-input v-model="p.desc" type="textarea" :row="2"></el-input>
                </el-form-item>
                <el-button type="primary" @click="deleteProjectName(item.index, index)">删除</el-button>
              </el-form>
            </div>
          </div>
        </div>
        <el-button type="primary" @click="addDirectionForm()">新增课题方向</el-button>

        <div slot="footer" class="dialog-footer">
          <el-button @click="editDirectionFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="editDirectionFormButton()">确 定</el-button>
        </div>
      </el-dialog>

    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      query: "", //查询信息
      users: [],
      //分页
      currentPage: 1,
      page_size: 10,
      total: 0,
      //添加用户 对话框属性
      addCategoryFormVisible: false,
      // 修改用户 对话框属性
      editCategoryFormVisible: false,
      formLabelWidth: "",
      addCategoryForm: {},
      // 添加用户对话框校验规则
      addCategoryFormRules: {
        // name: [{
        //   required: true,
        //   message: '请输入名称',
        //   trigger: 'blur'
        // },
        // {
        //   min: 2,
        //   max: 32,
        //   message: '长度在 2 到 32 个字符',
        //   trigger: 'blur'
        // }
        // ],
      },
      editUserForm: {},

      // 方向列表
      editDirectionFormVisible: false,
      category: '', //类别名称
      directions: [], //方向列表
      projectNames: [], //课题名称列表
    }
  },
  created() {
    this.getActivedCategory()
    this.getUsers(1, 10)
  },

  watch: {
    // 监听query变化
    directions: {
      handler(newVal, oldVal) {
        console.log('complexObject changed:', this.directions, newVal, oldVal);
      },
      deep: true
    }
  },

  methods: {
    // 获取激活课题类别数量，提示管理员
    async getActivedCategory() {
      const res1 = await this.axios.get(`/projectCategory/?is_active=True`)
      if (res1.status === 200) {
        if (res1.data.results.length != 1) {
          // this.$message.warning(`存在${res1.data.results.length}个激活类型，请立即修改！`)
        }
      } else {
        this.$message.warning("异常错误")
      }
    },

    //获取列表
    async getUsers(page, page_size) {
      const res = await this.axios.get(
        `/projectCategory/?page=${page}&page_size=${page_size}`
      )
      if (res.status === 200) {
        this.users = res.data.results
        this.total = res.data.count
        // console.log(res)
      } else {
        this.$message.warning("错误")
      }
    },
    //分页
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getUsers(this.currentPage, this.page_size)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getUsers(this.currentPage, this.page_size)
    },

    // 查询
    async queryUser() {
      const res = await this.axios.get(
        `/projectCategory/?page=${this.currentPage}&page_size=${this.page_size}&search=${this.query}`
      )
      if (res.status === 200) {
        this.users = res.data.results
        this.total = res.data.count
        // console.log(res)
      } else {
        this.$message.warning("错误")
      }
    },

    //添加
    showAddCategoryForm() {
      this.addCategoryFormVisible = true
    },

    async addCategorFormButton() {
      const res = await this.axios.post("/projectCategory/", this.addCategoryForm)
      this.addCategoryFormVisible = false
      this.getUsers(this.currentPage, this.page_size)
      this.getActivedCategory()
    },

    // 编辑
    async showEditCategoryForm(id) {
      const res = await this.axios.get('/projectCategory/' + id)
      if (res.status !== 200) {
        return this.$message.error('查询课题类别信息失败！')
      }
      this.editUserForm = res.data
      this.editCategoryFormVisible = true
    },

    editCategoryFormButton() {
      this.$confirm("此操作将修改课题类别信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var url = '/projectCategory/' + this.editUserForm.id + '/'
          // console.log(url)
          const res = await this.axios.put(url, this.editUserForm)
          if (res.status !== 200) {
            return this.$message.error('更新失败')
          }
          this.$message({
            type: "success",
            message: "修改成功!",
          })
          this.editCategoryFormVisible = false
          this.getUsers(this.currentPage, this.page_size)
          this.getActivedCategory()
        })
        .catch(() => {
          this.$message.error('更新失败')
        })
    },

    //删除
    deleteCategory(row) {
      this.$confirm("此操作将永久删除信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const resDel = await this.axios.delete(`/projectCategory/${row.id}`)
          // console.log('delete', resDel)
          if (resDel.status == 204) {
            this.$message({
              type: "success",
              message: "删除成功!",
            })
          }
          this.getUsers(this.currentPage, this.page_size)
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },

    //切换用户是否激活状态
    async categoryIsActive(row) {
      // console.log('row: ', row)
      var url = '/projectCategory/' + row.id + '/'
      var data = {
        name: row.name,
        is_active: row.is_active
      }
      const res = await this.axios.put(url, data)
      // const res = await this.axios.get(url)
      // console.log(res)
      if (res.status !== 200) {
        row.is_active = !row.is_active
        return this.$message.error('更新状态失败')
      }
      this.$message.success('更新状态成功！')
    },

    // 切换课题类别
    async changeType(row) {
      var url = '/projectCategory/' + row.id + '/'

      const res = await this.axios.put(url, row)
      // console.log(res)
      if (res.status !== 200) {
        return this.$message.error('更新用户状态失败')
      }
      this.$message.success('更新用户状态成功！')
    },

    // 课题方向编辑
    async showEditDirectionForm(row) {
      this.editDirectionFormVisible = true
      if (row.direction == null || row.direction.data == null) {
        this.directions = []
      } else {
        this.directions = row.direction.data
        // 增加临时index
        for (let i = 0; i < this.directions.length; i++) {
          this.directions[i].index = i
        }
      }
      this.category = row
    },

    addDirectionForm() {
      this.directions.push({
        index: this.directions.length,
        name: '',
        desc: '',
      })
    },

    deleteDirection(index) {
      this.directions.splice(index, 1)
    },

    // 新增课题名称
    addProjectName(i) {
      console.log('directions:', this.directions[i])
      // 历史问题，projectNames可能为空
      if (!this.directions[i].projectNames) {
        this.directions[i].projectNames = []
      }
      // this.directions[i].projectNames.push({
      //   name: ' ',
      //   desc: ' ',
      // })
      this.$set(this.directions[i].projectNames, this.directions[i].projectNames.length, {
        name: ' ',
        desc: ' ',
      })

      this.$nextTick(() => {
        // 强制更新视图，确保新添加的字段是响应式的
        this.$forceUpdate();
      });
    },

    // 删除课题名称
    deleteProjectName(i, j) {
      // console.log(i, j)
      //  弹出确认窗口
      this.$confirm('此操作将删除课题名称, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.directions[i].projectNames.splice(j, 1)
        // 强制刷新
        this.$forceUpdate()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    // 确定按钮
    async editDirectionFormButton() {
      // 删除index，防止点击删除按钮时报错
      for (let i = 0; i < this.directions.length; i++) {
        delete this.directions[i].index
      }
      this.category.direction = {
        data: this.directions
      }
      let res = await this.axios.put(`/projectCategory/${this.category.id}/`, this.category)
      if (res.status === 200) {
        this.$message.success('修改课题方向成功')
      }
      setTimeout(() => {
        this.editDirectionFormVisible = false
      }, 100);
    },

  },
}

</script>

<style lang="less" scoped>
.el-card {
  height: 100%;
  margin-top: 15px;
}

.row-search {
  margin-top: 20px;
}

.user-search {
  width: 420px;
}

.el-pagination {
  margin-top: 15px;
}

.el-col-user-add {
  display: flex;
}

.bt-user-add {
  margin-left: 10px;
}

.el-dialog {
  width: 60%;
}

.div-directions {
  padding: 20px;
  border: 1px solid;
  margin-bottom: 20px;
}

.div-projectNames {
  padding: 20px;
  border: 1px solid;
  margin-top: 20px;
  margin-bottom: 20px;
}

.form-projectNames {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/projectCategory/ProjectCategory.vue